import { render } from "./EditMutantModal.vue?vue&type=template&id=52be93d9&scoped=true"
import script from "./EditMutantModal.vue?vue&type=script&lang=js"
export * from "./EditMutantModal.vue?vue&type=script&lang=js"

import "./EditMutantModal.vue?vue&type=style&index=0&id=52be93d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52be93d9"]])

export default __exports__